/* eslint-disable */

import React from 'react';

const UIButton = ({
  text,
  handleClick,
}: {
  text: string,
  handleClick: () => void;
}) => {
  return (
    <button
      className="bg-main-blue text-white text-sm py-3 px-16 font-semibold shadow-lg rounded-lg hover:brightness-110 hover:shadow-xl active:scale-[0.98] transition-all duration-150"
      onClick={() => handleClick()}
    >
      {text}
    </button>
  );
};

export default UIButton;
